/**
 * Промокоди landing-акаунтів (кабінет головного користувача).
 */

export function getPromoCodes(partnerId) {
    return axios({
        url: `/api/partners/${partnerId}/promo-codes`,
        method: 'get',
    });
}

export function createPromoCode(partnerId, data) {
    return axios({
        url: `/api/partners/${partnerId}/promo-codes`,
        method: 'post',
        data: data,
    });
}

export function updatePromoCode(partnerId, promoCodeId, data) {
    return axios({
        url: `/api/partners/${partnerId}/promo-codes/${promoCodeId}`,
        method: 'put',
        data: data,
    });
}

export function deletePromoCode(partnerId, promoCodeId) {
    return axios({
        url: `/api/partners/${partnerId}/promo-codes/${promoCodeId}`,
        method: 'delete',
    });
}

export function getPromoCodeLink(partnerId, promoCodeId, productCode = 'tourism') {
    return axios({
        url: `/api/partners/${partnerId}/promo-codes/${promoCodeId}/link`,
        method: 'get',
        params: {
            productCode: productCode
        }
    });
}
